e.I.year_select = {
	year_list   : {},
	year_select : {},
	months_data : {},
	list_item : '',

	boxes : {},


	init : function(){
		_.bindAll( this, '_update_months' );
		this.year_list = $( '#previous-reports' );
		if( this.year_list.length === 0 ){
			return;
		}

		this.year_select = this.year_list.find( '#report-year' );
		this.months_data = JSON.parse( $( '#report-year-data' ).html() );
		this.list_item = $( '#handlebars-li' ).html();

		this.year_select.on( 'change', this._update_months );


		this._show_colored_boxes();
		this._update_months();
		this._view_dropdown();
	},

	_view_dropdown : function() {
		$('#view-dropdown').find( 'input').click(function() {
			if ($(this).is(':checked')) {
				$('#' + $(this).data('section')).show();
			} else {
				$('#' + $(this).data('section')).hide();
			}
		});
	},

	_show_colored_boxes : function(){
		$( '#general-stats' ).find( '.box' ).mouseover( function(){
			$( this ).find( '.colored-box' ).show();
		} ).mouseout( function(){
			$( this ).find( '.colored-box' ).hide();
		} );
	},


	_update_months : function(){
		var $year =  this.year_list.find( ':selected' ).val();

		this.year_list.find( 'li' ).not( '.save' ).remove();

		_.each( this.months_data[ $year ], function( month ){
			var li = Handlebars.compile( e.I.year_select.list_item );
			e.I.year_select.year_list.append( li( month ) );
		});

	}
};